
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

// 新增应聘人员
export function insertApplicant (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/interviewee',
    method: 'POST',
    data: parameter
  })
}
// 修改应聘人员
export function updateApplicant (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/interviewee',
    method: 'PUT',
    data: parameter
  })
}
// 删除应聘人员
export function deleteApplicant (ids) {
  return axios({
    url: sysInfo.apiRemote + '/interviewee?id=' + ids,
    method: 'DELETE'
  })
}
// 获取应聘人员列表
export function getApplicantList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/interviewee',
    method: 'GET',
    params: parameter
  })
}
// 修改应聘时间
export function changeApplicationTime (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/interviewee/book',
    method: 'PUT',
    data: parameter
  })
}
// 添加面试结果
export function applicationResult (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/interviewee/book',
    method: 'POST',
    data: parameter
  })
}
// 确认面试
export function confirmApplication (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/interviewee/book/confirm',
    method: 'PUT',
    data: parameter
  })
}
// 取消面试
export function cancelApplication (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/interviewee/book',
    method: 'DELETE',
    params: parameter
  })
}
// 获取面试结果信息
export function getApplicationResult (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/interviewee/book',
    method: 'GET',
    params: parameter
  })
}
// 入职
export function inductApplication (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/user/entry',
    method: 'PUT',
    data: parameter
  })
}
// 取消入职
export function rejectInduction (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/interviewee/entry/reject',
    method: 'PUT',
    data: parameter
  })
}